module.exports = {
      id: "photostory-usage",
      viewBox: "0 0 50.625 54",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#photostory",
      toString: function () {
        return this.url;
      }
    }